import {FileModel, INTRODUCER_KEY_TYPE} from "@/shared/model";
import * as z from "zod";
import {ManagerInformationModel} from "../../tax-corporation";

const customerSchema = z.object({
	id: z.optional(z.string()).nullable(),
	storeName: z.string().nullable(), // 상호명
	representativeName: z.string().nullable(), // 대표자명
	telephone: z.string().nullable()
});

const schema = z.object({
	id: z.string().nullable(),
	managerId: z.optional(z.string()).nullable(),
	department: z.optional(z.string()).nullable(),
	managerInformation: z.optional(ManagerInformationModel.model),

	introducerType: INTRODUCER_KEY_TYPE,
	introducerId: z.string().nullable(),
	introducerName: z.string().nullable(),
	introducedDate: z.string().nullable(),
	introducedCustomer: z.optional(customerSchema),
	introducedCustomerId: z.optional(z.string()).nullable(),

	content: z.string().optional().nullable(),
	memo: z.string().nullable(),
	files: z.array(FileModel.model).optional()
});

const model = schema.transform((values) => ({
	...values
}));

export const CustomerManagementResModel = {schema, model};
export type ICustomerManagementResModel = z.infer<typeof CustomerManagementResModel.model>;
export const DEFAULT_CUSTOMER_MANAGEMENT_RES: ICustomerManagementResModel = {
	id: null,
	managerId: null,
	// department: null,
	// managerInformation: DEFAULT_MANAGER_INFORMATION,

	introducerType: "TAX_ACCOUNTANT",
	introducerId: null,
	introducedDate: null,
	introducerName: null,
	introducedCustomerId: null,

	content: null,
	memo: null,
	files: []
};
